export const TOOLBAR_SHADOW = 'shadow-[0_0_0_1px_rgba(0,0,0,0.06),0_1px_2px_-1px_rgba(0,0,0,0.06)] new:shadow-card';
export const TOOLBAR_SHADOW_HOVER =
    'hover:shadow-[0_0_0_1px_rgba(0,0,0,0.1),0_1px_2px_-1px_rgba(0,0,0,0.08)] new:hover:shadow-peek';

export const FILTER_TRIGGER_CLASSES = `flex h-10 items-center gap-[7px] rounded-[10px] bg-paper px-3.5 text-[13px] font-medium text-grey-600 ${TOOLBAR_SHADOW} ${TOOLBAR_SHADOW_HOVER}`;
